import React, { useState } from "react";
import SearchInputAccordionItem from "./common-components/SearchInputAccordionItem";
import {
  HTTP_STATUS_CODE_200,
  HTTP_STATUS_CODE_400,
  HTTP_STATUS_CODE_504,
  doPost,
} from "../../../utils/apiUtils";
import { log } from "../../../utils/ALL/loggingUtils";
import { PROCESS_AGENT_ID } from "../views/D101ProcessSearchUtils";

const D101ProcessAgentIdSearch = ({
  eventKey,
  setProcessAgentIdSearch,
  setIsLoading,
  setIsFailedToRetrieveData,
  setErrorMessage,
  setSearchType,
}) => {
  const [agentId, setAgentId] = useState("");
  const handleAgentIdSearch = async (event) => {
    event.preventDefault();

    try {
      setIsLoading(true);
      setIsFailedToRetrieveData(false);
      setSearchType(PROCESS_AGENT_ID);
      let searchParams = {
        agentId,
      };

      setProcessAgentIdSearch([]);

      log(searchParams);
      const postResponse = await doPost(
        `${process.env.REACT_APP_BASE_API_ENDPOINT}/search/process-agentId`,
        searchParams
      );

      if (postResponse.status === HTTP_STATUS_CODE_400) {
        log("Got 400 status code from API");
        setErrorMessage("Error while processing request");
        setIsFailedToRetrieveData(true);
      } else if (postResponse.status === HTTP_STATUS_CODE_200) {
        setProcessAgentIdSearch(postResponse.data);
        log(postResponse.data);
        setIsFailedToRetrieveData(false);
        setErrorMessage("");
      } else if (postResponse.status === HTTP_STATUS_CODE_504) {
        setErrorMessage("Taking too long to process the request");
        setProcessAgentIdSearch([]);
        setIsFailedToRetrieveData(true);
      } else {
        log("Unhandled http status code");
        setProcessAgentIdSearch([]);
        setIsFailedToRetrieveData(true);
      }
      setIsLoading(false);
    } catch (error) {
      log("error in getting NMI details");
      log(error);
      setErrorMessage("Error while retrieving data");
      setIsFailedToRetrieveData(true);
      setIsLoading(false);
    }
  };
  const agentIdSearchProps = {
    eventKey,
    accordionHeaderTitle: "Agent ID​​",
    formLabel: "Agent ID​",
    formControlName: "agentId",
    onChange: setAgentId,
    onButtonClick: handleAgentIdSearch,
    isSearchButtonDisabled: false,
  };
  return (
    <SearchInputAccordionItem
      {...agentIdSearchProps}
    ></SearchInputAccordionItem>
  );
};

export default D101ProcessAgentIdSearch;
